(function() {
    angular
        .module("usersModule")
        .config(usersRouter)

    usersRouter.$inject = [
        "$stateProvider",
        "$urlRouterProvider",
        "$locationProvider"
    ]

    function usersRouter(
        $stateProvider,
        $urlRouterProvider,
        $locationProvider
    ){
        $stateProvider
            .state("users", {
                url: "/users",
                templateUrl: "app/components/users/users.view.html",
                controller : "UsersController"
            })
            .state("customer-users", {
                url: "/users/customer-id/:customer_id",
                templateUrl: "app/components/users/users.view.html",
                controller : "UsersController"
            })
            .state("user-details", {
                url: "/user-details/id/:user_id",
                templateUrl: "app/components/users/details.view.html",
                controller : "UserDetailsController"
            })
            .state("current-user-details", {
                url: "/current-user-details",
                templateUrl: "app/components/users/users.view.html",
                controller : "UsersController"
            })
            .state("user-new", {
                url: "/user-new",
                templateUrl: "app/components/users/new.view.html",
                controller : "UserNewController"
            })

            $urlRouterProvider.otherwise("/")

        $locationProvider.html5Mode(true)
    }
})()
